import { z } from 'zod';

// Form schema - values are strings from select inputs
export const initialIncidentsSettingsSchema = z.object({
  incident: z.string().min(1, 'Data viewing incident is required.'),
  dataGathering: z.string().min(1, 'Data gathering incident is required.'),
  group: z.string().min(1, 'County is required.'),
});

// Non-admin variant: dataGathering is optional (read-only for non-admins)
export const initialIncidentsReadOnlyGatheringSchema = z.object({
  incident: z.string().min(1, 'Data viewing incident is required.'),
  dataGathering: z.string().optional(),
  group: z.string().min(1, 'County is required.'),
});

export type InitialIncidentsFormSchema = z.infer<typeof initialIncidentsSettingsSchema>;
